import React from 'react'

import {
  annualLimits,
  annualUrl,
  freeLimits,
  usageBasedLimits,
} from './constants/Plans'

import PlanCard, {PlanType} from './PlanCard'

interface Props {
  influxdbURL: string
}

const OnboardingCards = ({influxdbURL}: Props): JSX.Element => {
  return (
    <div className="plan-cards">
      <PlanCard
        billingInfo="No credit card required"
        buttonText="Keep"
        buttonURL={influxdbURL}
        className="plan-card--onboarding"
        description="I'm a hobbyist"
        icon={<div className="plan-cards--graphic plan-cards--graphic__free" />}
        limitations={freeLimits}
        planType={PlanType.Free}
        title="Free"
      />
      <PlanCard
        bannerDetails="(valid for 30 days after signup)"
        bannerTitle="Upgrade now to get $250 in credit"
        billingInfo="Billed monthly"
        buttonText="Upgrade Now"
        buttonURL="/checkout"
        className="plan-card--onboarding"
        description="I know my workload"
        icon={
          <div className="plan-cards--graphic plan-cards--graphic__payg plan-cards--focus" />
        }
        isHighlighted={true}
        limitations={usageBasedLimits}
        planType={PlanType.UsageBased}
        title="Usage-Based"
      />
      <PlanCard
        billingInfo="Yearly Contract"
        buttonText="Contact Sales"
        buttonURL={annualUrl}
        className="plan-card--onboarding"
        description="Enterprise scale"
        icon={
          <div className="plan-cards--graphic plan-cards--graphic__annual" />
        }
        limitations={annualLimits}
        openTab={true}
        planType={PlanType.Annual}
        title="Annual"
      />
    </div>
  )
}

export default OnboardingCards
